import React, {useState} from 'react';
import {
	createSearchParams,
	useNavigate,
	useOutletContext,
	useSearchParams,
} from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import { TextHighlighter } from '../shared/textBold';
import { decodeName } from '../utils';
import { useSelector } from 'react-redux';
import { useBuildModel } from './hooks';

import { useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { toast } from 'react-toastify';

export const VendorListingData = () => {
	const { vendorList, Search, isValidLicence } = useOutletContext();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const build_model_hook = useBuildModel();
	const PrivilagesList = useSelector(
		(state) => state?.privilageSlice?.allowedActions
	);

	const [menuState, setMenuState] = useState({ anchorEl: null, row: null });

	const handleClickListItem = (event, itm) => {
		setMenuState({ anchorEl: event.currentTarget, row: itm });
	};

	const handleClose = () => {
		setMenuState({ anchorEl: null, row: null });
	};

	function handleNavigate(obj) {
		const encodedClientName = encodeURIComponent(
			decodeName(searchParams.get('client_name'))
		);
		const encodedVendorName = encodeURIComponent(obj.vendor_name);
		const encodeCategoryName = encodeURIComponent(obj.category_name);
		navigate({
			pathname: '/my-invoices',
			search: createSearchParams({
				client_id: searchParams.get('client_id'),
				client_name: encodedClientName,
				client_list_page_no: searchParams.get('client_list_page_no'),
				client_list_sort_key: searchParams.get('client_list_sort_key'),
				client_list_sort_order: searchParams.get('client_list_sort_order'),

				vendor_id: obj.vendor_id,
				vendor_name: encodedVendorName,
				vendor_list_page_no: searchParams.get('vendor_list_page_no'),
				vendor_list_sort_key: searchParams.get('vendor_list_sort_key'),
				vendor_list_sort_order: searchParams.get('vendor_list_sort_order'),
				category_name: encodeCategoryName,
				category_id: obj.category_id,

				invoice_list_page_no: 1,
				invoice_list_sort_key: '',
				invoice_list_sort_order: '',
			}).toString(),
		});
	}

	function handleNavigateToContracts(obj) {
		const encodedClientName = encodeURIComponent(
			decodeName(searchParams.get('client_name'))
		);
		const encodedVendorName = encodeURIComponent(obj.vendor_name);
		const encodeCategoryName = encodeURIComponent(obj.category_name);
		navigate({
			pathname: '/my-contracts',
			search: createSearchParams({
				client_id: searchParams.get('client_id'),
				client_name: encodedClientName,
				client_list_page_no: searchParams.get('client_list_page_no'),
				client_list_sort_key: searchParams.get('client_list_sort_key'),
				client_list_sort_order: searchParams.get('client_list_sort_order'),

				vendor_id: obj.vendor_id,
				vendor_name: encodedVendorName,
				vendor_list_page_no: searchParams.get('vendor_list_page_no'),
				vendor_list_sort_key: searchParams.get('vendor_list_sort_key'),
				vendor_list_sort_order: searchParams.get('vendor_list_sort_order'),
				category_name: encodeCategoryName,
				category_id: obj.category_id,

				contract_list_page_no: 1,
				contract_list_sort_key: '',
				contract_list_sort_order: '',
			}).toString(),
		});
	}

	function isDisable(itm) {
		if (itm.disable) {
			return true;
		} else if ("eta" in itm){
			return true
		}
		else if (itm.total_invoices === 0) {
			return true;
		} else if (itm.vendor_id == null || itm.category_id == null) {
			return true;
		} else {
			return false;
		}
	}

	function isDisableContractBtn(itm) {
		if (itm.disable) {
			return true
		}
		if (itm.total_contracts === 0) {
			return true;
		} else if (itm.vendor_id == null || itm.category_id == null) {
			return true;
		} else {
			return false;
		}
	}

	function buttonDisableScenario(itm) {
		if (itm.disable) {
			return {
				disable: true,
				lable: 'View Invoices',
				title: 'Model building in progress',
			};
		} else if (itm.vendor_id == null || itm.category_id == null) {
			return { disable: true, lable: 'View Invoices', title: 'Vendor or Category missing' };
		} else if (itm.total_invoices === 0) {
			return { disable: true, lable: 'View Invoices', title: 'No Invoice found'  };
		} else {
			return { disable: false, lable: 'View Invoices' };
		}
	}

	function buttonDisableScenarioContract(itm) {
		if (itm.disable) {
			return {
				disable: true,
				lable: 'View Contracts',
				title: 'Model building in progress',
			};
		} else if (itm.vendor_id == null || itm.category_id == null) {
			return { disable: true, lable: 'View Contracts', title: 'Vendor or Category missing' };
		} else if (itm.total_contracts === 0) {
			return { disable: true, lable: 'View Contracts', title: 'No Contract found' };
		} else {
			return { disable: false, lable: 'View Contracts' };
		}
	}

	function handleBuildModelClicked(build_from_scratch, vid, cid) {
		let body = {
			data: {
				client_id: searchParams.get('client_id'),
				build_from_scratch: build_from_scratch,
				vendor_ids: [
					{
						vendor_id: vid,
						category_id: cid,
					},
				],
			},
		};
		build_model_hook.mutate(body);
	}

	return (
		<>
			{vendorList?.data?.map((itm, ind) => {
				return (
					<div key={`vendor` + ind} className="flex gap-2 mb-2 tblLoop">
						<div className="flex-none">
							<label className="vLBG flex items-center px-3 h-[53px] rounded-md text-center text-white relative text-sm">
								<img className="h-8" src="/svg/ri_building-fill.svg" alt="" />
							</label>
						</div>
						<div className="growS flex-none min-w-[900px] 2xl:grow 2xl:w-auto border rounded-md px-5 py-3 text-sm flex items-center justify-between">
							<div className="grow border-r pr-4 flex items-center">
								{/* Name */}
								<div className="flex-1 truncate">
									<TextHighlighter text={itm.vendor_name} searchString={Search} />
								</div>

								{/* Actions */}
								
							</div>

							<div className="flex-none border-r px-4 text-center w-[140px] block text-ellipsis overflow-hidden whitespace-nowrap">
								{itm.category_name}
							</div>
							<div className="flex-none border-r px-4 text-center w-[110px]">
								{itm.document_annotated}
							</div>
							<div className="flex-none px-4 text-center w-[90px]">
								{itm.total_invoices}
							</div>
							<div className="flex-none border-r px-4 text-center w-[110px]">
								{itm.total_contracts}
							</div>

							<div className="flex-none px-2 text-center w-[120px]">
								<span className="inline-block w-2 h-2 rounded-full bg-gray-600 mx-1"></span>
								<span className="inline-block w-2 h-2 rounded-full bg-gray-400 mx-1"></span>
								<span className="inline-block w-2 h-2 rounded-full bg-gray-200 mx-1"></span>
								{itm?.percentage_complete}%
							</div>
						</div>

						<div className="flex-none flex pr-2">
							<button
								disabled={isDisable(itm)}
								onClick={() => handleNavigate(itm)}
								title={buttonDisableScenario(itm).title}
								type="button"
								className="w-[130px] vLBG block px-0 py-3 text-center text-primary text-sm rounded-md font-black mx-1 disabled:bg-gray-200 disabled:text-gray-500"
							>
								{buttonDisableScenario(itm).lable}
							</button>
							<button
								disabled={isDisableContractBtn(itm)}
								onClick={() => handleNavigateToContracts(itm)}
								title={buttonDisableScenarioContract(itm).title}
								type="button"
								className=" w-[130px] vLBG block px-0 py-3 text-center text-primary text-sm rounded-md font-black mx-1 disabled:bg-gray-200 disabled:text-gray-500"
							>
								{buttonDisableScenarioContract(itm).lable}
							</button>
							{PrivilagesList.includes('trigger_build_model') && (
									<div className="ml-2">
										{itm?.disable == true ? (
											<div className=" w-[130px] vLBG h-full block px-0 py-3 text-center text-primary text-sm rounded-md font-black mx-1 disabled:bg-gray-200 disabled:text-gray-500">
												{itm.eta}
											</div>
										) : (
											<>
												<ListItem
													id="export-button"
													aria-haspopup="listbox"
													aria-controls="export-menu"
													aria-expanded={
														Boolean(menuState.anchorEl) ? 'true' : undefined
													}
													onClick={(e) => handleClickListItem(e, itm)} // pass itm here
													className="cursor-pointer w-[130px] vLBG h-full block px-0 py-3 text-center text-primary text-sm rounded-md font-black mx-1 disabled:bg-gray-200 disabled:text-gray-500"
												>
													{build_model_hook.isPending
														? 'Wait...'
														: 'Build model'}
													<span className="material-icons text-sm ml-1">
														expand_more
													</span>
												</ListItem>

												<Menu
													id="export-menu"
													className="expMenu"
													anchorEl={menuState.anchorEl}
													open={Boolean(menuState.anchorEl)}
													onClose={handleClose}
													MenuListProps={{
														'aria-labelledby': 'export-button',
														role: 'listbox',
													}}
												>
													<MenuItem
														disabled={
															!isValidLicence || build_model_hook.isPending
														}
														onClick={() =>
															handleBuildModelClicked(
																false,
																menuState.row.vendor_id,
																menuState.row.category_id
															)
														}
													>
														<span className="material-icons text-sm mr-3">
															redo
														</span>
														{build_model_hook.isPending
															? 'Build in Progress'
															: 'Build New Version'}
													</MenuItem>

													<MenuItem
														disabled={
															!isValidLicence || build_model_hook.isPending
														}
														onClick={() =>
															handleBuildModelClicked(
																true,
																menuState.row.vendor_id,
																menuState.row.category_id
															)
														}
													>
														<span className="material-icons text-sm mr-3">
															check
														</span>
														{build_model_hook.isPending
															? 'Build in Progress'
															: 'Build From Scratch'}
													</MenuItem>
												</Menu>
											</>
										)}
									</div>
								)}
						</div>
					</div>
				);
			})}
		</>
	);
};
